export default __webpack_public_path__ + "static/media/logo_sbb.986fa24d.svg";